// extracted by mini-css-extract-plugin
export var form = "_ed-0";